import Vue from 'vue';
import App from './App.vue';

window.vue_subscription_popup = new Vue({
  el: '#vue_subscription_popup',
  render: h => h(App)
});

window.jQuery('.vue_subscription_popup_open_button').live('click', function() {
  window.vue_subscription_popup.$children[0].setOrderData(
      JSON.parse(MPopup.getParams("nc_subscription_payment"))
  );

  if (window.vue_new_company_configurator.$children[0].$store.getters.legalFormDisabled) {
    window.echo('Выберите тип компании.');
  } else if (!window.vue_new_company_configurator.$children[0].$store.getters["tree/hasSelectedCities"]) {
    window.echo('Выберите города.');
  } else {
    window.vue_subscription_popup.$children[0].open();
  }
});
